module.exports = __webpack_public_path__ + "img/Feature.39f86802.png";